import { render } from "./ProductLabelPrintDialog.vue?vue&type=template&id=4f593163&scoped=true"
import script from "./ProductLabelPrintDialog.vue?vue&type=script&lang=js"
export * from "./ProductLabelPrintDialog.vue?vue&type=script&lang=js"

import "./ProductLabelPrintDialog.vue?vue&type=style&index=0&id=4f593163&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f593163"]])

export default __exports__